import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { DLBanner } from '@/components/general/DLBanner';
import { getScreen } from '@/styles/media-query';
import { Link, withPrefix } from 'gatsby';

export type TaskSupportSectionProps = {
  className?: string;
};

export const TaskSupportSection: React.FC<TaskSupportSectionProps> = ({
  className,
}) => {
  return (
    <section
      css={css`
        position: relative;
        padding: 0 0 80px;
        background: transparent linear-gradient(237deg, #DEF6F5 0%, #FFFFFF 100%) 0% 0% no-repeat padding-box;
        
        @media ${getScreen('pc')} {
          
        }
      `}
      className={className}
    >
      <div 
        css={css`
          width: 100%;
          max-width: 1040px;
          padding-bottom: 40px;
          margin: auto;
          margin-bottom: 50px;
          border-radius: 38px;
          background: #ffffff;
          box-shadow: 0px 0px 16px rgba(44, 40, 40, 0.11);
          
          transform: translateY(-20px);
          position: relative;
          z-index: 10;
          
          @media ${getScreen('pc')} {
            margin-bottom: -30px;
            padding: 20px;
            padding-bottom: 50px;

            transform: translateY(-100px);
          }
        `}
      >
        <div 
          css={css`
            position: relative;
            z-index: 5;
            padding-bottom: 10px;
            margin-bottom: 80px;
            border-radius: 20px 20px 0 0;
            background: #cff5f3;
            
            @media ${getScreen('pc')} {
              border-radius: 38px 38px 0 0;
            }
            
            &::after {
              content: '';
              position: absolute;
              z-index: -1;
              bottom: -40px;
              display: block;
              width: 100%;
              height: 76px;
              border-radius: 50%;
              background: #cff5f3;
              
              @media ${getScreen('pc')} {
                bottom: -38px;
              }
              
            }
            
          `}
        >
          <p
            css={css`
              display: flex;
              align-items: flex-end;
              justify-content: center;
              gap: 10px;
              padding: 25px 5px 10px;
              margin-bottom: 20px;
              font: normal normal bold 16px/33px Noto Sans JP;
              text-align: center;
              
              @media ${getScreen('pc')} {
                gap: 20px;
                padding: 40px 25px 10px;
                font-size: 21px;
              }
              
              strong {
                display: inline-flex;
                justify-content: center;
                align-items: center;
                width: auto;
                height: 40px;
                padding: 10px 15px;
                border-radius: 20px;
                font: normal normal bold 12px/12px Noto Sans JP;
                color: #00B3A7;
                background: #ffffff;
                
                @media ${getScreen('pc')} {
                  width: 190px;
                  height: 50px;
                  border-radius: 25px;
                  font: normal normal bold 20px/20px Noto Sans JP;
                }
              }
            `}
          >
            <strong>経営者</strong><strong>経営企画</strong><strong>管理部</strong>の皆さま
          </p>
          <h2
            css={css`
              font: normal normal bold 18px/25px Noto Sans JP;
              font-weight: bold;
              text-align: center;
              
              @media ${getScreen('pc')} {
                font: normal normal bold 30px/33px Noto Sans JP;
              }
              
              strong {
                font-size: 23px;
                line-height: 30px;
                color: #00B3A7;
                
                @media ${getScreen('pc')} {
                  font-size: 34px;
                  line-height: 40px;
                }
              }
            `}
          >
            <strong>IPO・M&Aの準備</strong>に携わる<br
              css={css`
                @media ${getScreen('pc')} {
                  display: none;
                }
              `}
            /><strong>皆さまの業務</strong>を<strong>徹底サポート</strong>！
          </h2>
          
        </div>
        <div 
          css={css`
            position: relative;
            z-index: 10;
            display: block;
            justify-content: space-between;
            gap: 40px;
            padding: 20px;
            margin-bottom: 30px;
            
            @media ${getScreen('pc')} {
              display: flex;
            }
            
            &::after {
              position: absolute;
              top: -25px;
              left: 0;
              right: 0;
              width: 1px;
              height: calc(100% + 50px);
              margin: auto;
              border-left: 4px dashed #00B3A7;
              opacity: 0.19;
              
              @media ${getScreen('pc')} {
                content: "";
              }
            }
            
            section {
              position: relative;
              width: 100%;
              padding: 0 25px 25px;
              border-radius: 16px;
              background: #eaf9f8;
              
              @media ${getScreen('pc')} {
                width: 50%;
              }
              + section {
                margin-top: 70px;
                
                @media ${getScreen('pc')} {
                  margin-top: 0;
                }
              }
            }
            h3 {
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90%;
              height: 50px;
              padding: 5px 15px;
              margin: auto;
              border-radius: 30px;
              font: normal normal bold 20px/20px Noto Sans JP;
              text-align: center;
              color: #ffffff;
              background: #00b3a7;
              
              transform: translateY(-50%);
              
              @media ${getScreen('pc')} {
                width: 80%;
              }
            }
            li {
              padding: 20px;
              border-radius: 16px;
              background: #ffffff;
              + li {
                margin-top: 15px;
              }

              dt {
                position: relative;
                display: block;
                padding-left: 20px;
                margin-bottom: 10px;
                font: normal normal bold 20px/23px Noto Sans JP;
                color: #00B3A7;
                
                &::before {
                  content: "";
                  position: absolute;
                  left: 0;
                  top: 7px;
                  display: inline-block;
                  width: 12px;
                  height: 12px;
                  margin: auto;
                  font-size: 0;
                  border: 3px solid #00B3A7;
                  border-radius: 12px;
                  background: #9FE2DF;
                }
                
                small {
                  font-size: 12px;
                }
              }
              dd {
                font: normal normal 500 14px/21px Noto Sans JP;
                
                @media ${getScreen('pc')} {
                  font: normal normal 500 16px/24px Noto Sans JP;
                }
              }
            }
          `}
        >
          <section>
            <h3>経営者（経営管理）
              <img
                css={css`
                  position: absolute;
                  right: 10px;
                  bottom: -10px;
                  z-index: 10;
                  width: 25px;
                  
                  @media ${getScreen('pc')} {
                    width: 38px;
                  }
                `}
                src={withPrefix('/images/task/tasksupport-human_1.png')}
                alt=""
              />
            </h3>
            <div><ul>
              <li><dl>
                <dt>経営管理体制の構築を徹底サポート</dt>
                <dd>明日起こるかもしれない経営のヒヤリを事前に把握して先回り！</dd>
              </dl></li>
              <li><dl>
                <dt>資本政策表の作成～共有がスムーズ</dt>
                <dd>複雑な資本政策表をミス・ムダなく作成！エクセル出力も可能なので外部との共有もラクラク。</dd>
              </dl></li>
              <li><dl>
                <dt>全体像や進捗状況が一目瞭然</dt>
                <dd>対応に時間を要するテーマや、上場延期に繋がるネガティブサプライズを未然に防止</dd>
              </dl></li>
            </ul></div>
          </section>
          
          <section>
            <h3>実務のご担当者
              <img
                css={css`
                  position: absolute;
                  right: 10px;
                  bottom: -10px;
                  z-index: 10;
                  width: 30px;
                  
                  @media ${getScreen('pc')} {
                    width: 40px;;
                  }
                `}
                src={withPrefix('/images/task/tasksupport-human_2.png')}
                alt=""
              />
            </h3>
            <div><ul>
              <li><dl>
                <dt>IPO・M&Aの経験者がいなくても安心</dt>
                <dd>知識や経験がなくても、ほしい情報がすぐに見つかる！全体像を把握しながら自社で準備が可能に。</dd>
              </dl></li>
              <li><dl>
                <dt>セルフチェックで自社の課題を把握</dt>
                <dd>ショートレビューや労務DDも事前にセルフチェックが可能！専門知識いらずで課題を把握。</dd>
              </dl></li>
              <li><dl>
                <dt>コミュニケーションが円滑に</dt>
                <dd>課題一覧、スケジュール、テンプレート、自社資料まで社内外のコミュニケーションも円滑に！</dd>
              </dl></li>
            </ul></div>
          </section>
        </div>
        <div 
          css={css`
            position: relative;
            max-width: 960px;
            padding: 20px;
            margin-left: 20px;
            margin-right: 20px;
            border-radius: 16px;
            background: #caefed;
            
            @media ${getScreen('pc')} {
              padding: 30px;
              margin-left: auto;
              margin-right: auto;
            }
            
            dl {
              display: block;
              justify-content: space-between;
              align-items: center;
              gap: 25px 40px;
              padding: 20px;
              border-radius: 8px;
              background: #ffffff;
              
              @media ${getScreen('pc')} {
                display: flex;
                padding: 30px;
              }
              
              + dl {
                margin-top: 15px;
              }
            }
            dt {
              flex-shrink: 0;
              position: relative;
              width: 100%;
              padding-left: 20px;
              font: normal normal bold 20px/29px Noto Sans JP;
              color: #00B3A7;
              
              @media ${getScreen('pc')} {
                width: 290px;
              }
              
              &::before {
                content: "";
                flex-shrink: 0;
                position: absolute;
                top: 10px;
                left: 0;
                display: inline-block;
                width: 12px;
                height: 12px;
                margin: auto;
                font-size: 0;
                border: 3px solid #00B3A7;
                border-radius: 12px;
                background: #9FE2DF;
              }
              
              small {
                font-size: 12px;
              }
            }
            dd {
              font: normal normal 500 14px/21px Noto Sans JP;
              letter-spacing: 0.32px;
              
              @media ${getScreen('pc')} {
                font: normal normal 500 16px/24px Noto Sans JP;
              }
            }
          `}
        >
          <dl>
            <dt>困ったときはすぐに専門家へ相談が可能なので安心</dt>
            <dd>わからないことはすぐに相談！各専門家があなたのお困りごとを解決します。VC、銀行、金融へのご紹介や社労士・税理士・弁理士などの専門家へのご相談もUniforceが窓口となって対応いたします。</dd>
          </dl>
          <dl>
            <dt>アドバイスからリソース不足の解消まで徹底的にサポート</dt>
            <dd>Uniforceのアドバイザーやコンサルタントが実務上での不明点やご相談に対応します。リソースが不足していても、不足分を提供することも可能です。</dd>
          </dl>
          
          <img
            css={css`
              position: absolute;
              left: 0px;
              bottom: -10px;
              width: 40px;
              
              display: none;
              
              @media ${getScreen('pc')} {
                display: block;
              }
              
            `}
            src={withPrefix('/images/task/tasksupport-human_3.png')}
            alt=""
          />
          
          <img
            css={css`
              position: absolute;
              right: 0px;
              bottom: -10px;
              width: 42px;
              
              display: none;
              
              @media ${getScreen('pc')} {
                display: block;
              }
              
            `}
            src={withPrefix('/images/task/tasksupport-human_4.png')}
            alt=""
          />
          
        </div>
      </div>
      
      <DLBanner />
    </section>
  );
};
